import {
    StyleSheet
} from "react-native";
import type {
    BarChartSignKeyDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 0
    }
});

export const useStyles = ({
    shapeConfigs,
    radiuses,
    color
}: BarChartSignKeyDynamicStyleType) => {
    const styles = {
        container: {
            height: shapeConfigs.chartDotSize,
            width: shapeConfigs.chartDotSize,
            borderRadius: radiuses.xs / 2,
            backgroundColor: color
        }
    };

    return styles;
};
export default stylesheet;
